module.exports = __webpack_public_path__ + "static/media/JINGLE_END_FAST.0bbf56de.mp3";